<div class="heading">Kein Zugang</div>
<div class="description">Sie sind für diese Applikation nicht autorisiert.</div>
<div (click)="logout()" class="home">Abmelden</div>
